import {
  AdminItemsRow,
  AdminItemsContainer,
  AdminItemContainer,
} from "../../../admin.styled";
import { useState } from "react";
import { formatDate } from "core/lib/utils";

export default function AdminReport({ feedbackItem }) {
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const [openRow, setRowOpen] = useState(false);

  return (
    <AdminItemsRow>
      <div className="unexpanded-row-container">
        <div className="row-items" onClick={() => setRowOpen(!openRow)}>
          <p className="row-item">{feedbackItem.model}</p>
          <p className="row-item">{feedbackItem.negative === true ? "Positive" : "Negative"}</p>
          <p className="row-item">{formatDate(feedbackItem.createdAt)}</p>
        </div>
        <div className="row-buttons">
          
        </div>
      </div>

      {openRow && (
        <AdminItemsContainer>
          <AdminItemContainer className="d-flex flex-row">
            <strong>Sentiment:</strong>
            <p className="ps-1">{feedbackItem.negative === true ? "Positive" : "Negative"}</p>
          </AdminItemContainer>

          <AdminItemContainer className="d-flex flex-row">
            <strong>Model:</strong>
            <p className="ps-1">{feedbackItem.model}</p>
          </AdminItemContainer>

          <AdminItemContainer className="d-flex flex-row">
            <strong>Comment:</strong>
            <p className="ps-1">{feedbackItem.note}</p>
          </AdminItemContainer>

          <AdminItemContainer className="d-flex flex-row">
            <strong>Converation ID:</strong>
            <p className="ps-1">{feedbackItem.conversationid.length > 0 ? feedbackItem.conversationid : "None"}</p>
          </AdminItemContainer>

          <AdminItemContainer className="d-flex flex-row">
            <strong>Created At:</strong>
            <p className="ps-1">{feedbackItem.createdAt}</p>
          </AdminItemContainer>

          <AdminItemContainer className="d-flex flex-row">
            <strong>Updated At:</strong>
            <p className="ps-1">{feedbackItem.updatedAt}</p>
          </AdminItemContainer>
        </AdminItemsContainer>
      )}
    </AdminItemsRow>
  );
}
